






































































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  workflow_storage,
  workflow_marketplace_item,
} from "@/shared/services/workflow_storage";
import { MessageService } from "@/shared/services/message-service";
import { RouterNames } from "@/router/routernames";

@Component({ components: {} })
export default class WorkFlowsManager extends Vue {
  searchQuery: string = "";
  activeFilter: string = "all";
  refreshKey: number = 0;
  isRefreshing: boolean = false; // Estado de carga para el botón

  filters = [
    { label: "Todos", value: "all" },
    { label: "Recientes", value: "recent" },
    { label: "Favoritos", value: "favorites" },
    { label: "Compartidos", value: "shared" },
  ];

  _savedWorkflows: workflow_marketplace_item[] = [];

  get savedWorkflows(): workflow_marketplace_item[] {
    // Usar refreshKey para forzar recálculo
    this.refreshKey;
    return workflow_storage.list();
  }

  set savedWorkflows(value: workflow_marketplace_item[]) {
    this._savedWorkflows = value;
  }

  get filteredWorkflows(): workflow_marketplace_item[] {
    let workflows = this.savedWorkflows;

    // Filtro por búsqueda
    if (this.searchQuery) {
      const query = this.searchQuery.toLowerCase();
      workflows = workflows.filter(
        (w) =>
          w.name.toLowerCase().includes(query) ||
          (w.description && w.description.toLowerCase().includes(query))
      );
    }

    // Filtro por categoría
    switch (this.activeFilter) {
      case "recent":
        workflows = workflows
          .sort(
            (a, b) =>
              new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
          )
          .slice(0, 10);
        break;
      case "favorites":
        //  workflows = workflows.filter((w) => w.isFavorite);
        break;
      case "shared":
        // workflows = workflows.filter((w) => w.isShared);
        break;
    }

    return workflows;
  }

  // === Acciones de administración ===
  createNewWorkflow() {
    this.$emit("create-new");
    var newWorkflow = workflow_storage.new();
    this.selectWorkflow(newWorkflow);
    this.refreshData();
    MessageService.toast("Nuevo workflow creado", MessageService.TypeInfo);
  }

  triggerImport() {
    const el = this.$refs.fileInput as HTMLInputElement;
    if (el) el.click();
  }

  public handleImportChange(e: Event): void {
    const input = e.target as HTMLInputElement;
    const files = input && input.files ? input.files : null;
    if (!files || files.length === 0) return;

    let importedCount = 0;
    const totalFiles = files.length;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const reader = new FileReader();

      reader.onload = (ev: ProgressEvent<FileReader>) => {
        try {
          const text =
            ev && ev.target && ev.target.result ? String(ev.target.result) : "";
          const json = JSON.parse(text);
          workflow_storage.importFromJson(json as workflow_marketplace_item);
          importedCount++;

          // Solo mostramos el mensaje una vez, al completar el último archivo
          if (importedCount === totalFiles) {
            this.refreshData(); // Refrescar después de importar
            MessageService.toast(
              "Workflows importados correctamente",
              MessageService.TypeSuccess
            );
          }
        } catch (err) {
          MessageService.toast(
            "Error al importar archivo",
            MessageService.TypeError
          );
        }
      };

      reader.readAsText(file);
    }

    // Limpia el input para permitir volver a importar
    if (input) {
      input.value = "";
    }
  }

  exportAll() {
    const workflows = this.savedWorkflows;
    const dataStr = JSON.stringify(workflows, null, 2);
    const dataBlob = new Blob([dataStr], { type: "application/json" });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `workflows-backup-${
      new Date().toISOString().split("T")[0]
    }.json`;
    link.click();
    URL.revokeObjectURL(url);
    MessageService.toast(
      "Todos los workflows exportados",
      MessageService.TypeSuccess
    );
  }

  setFilter(filterValue: string) {
    this.activeFilter = filterValue;
  }

  openWorkflow(id: string) {
    this.$router
      .push({ name: RouterNames.workflows_id, params: { id: id } })
      .catch(function() {});
  }
  // === Acciones de workflow ===
  selectWorkflow(workflow: workflow_marketplace_item) {
    this.$emit("select-workflow", {
      name: workflow.name,
      id: workflow.id,
      createdAt: workflow.createdAt,
      updatedAt: workflow.updatedAt,
      nodes: workflow.nodes ? [...workflow.nodes] : [],
      connections: workflow.connections ? [...workflow.connections] : [],
    });
    this.openWorkflow(workflow.id);
  }

  editWorkflow(workflow: workflow_marketplace_item) {
    this.selectWorkflow(workflow);
  }
  chatWorkflow(workflow: workflow_marketplace_item) {
    this.$router
      .push({ name: RouterNames.chat_workflow, params: { id: workflow.id } })
      .catch(function() {});
  }

  duplicateWorkflow(workflow: workflow_marketplace_item) {
    var duplicated = workflow_storage.duplicate(workflow);
    this.selectWorkflow(duplicated);
    this.refreshData(); // Refrescar después de duplicar
    MessageService.toast(
      "Workflow duplicado correctamente",
      MessageService.TypeSuccess
    );
  }

  exportWorkflow(workflow: workflow_marketplace_item) {
    workflow_storage.exportToFile(workflow);
    MessageService.toast(
      "Workflow exportado correctamente",
      MessageService.TypeSuccess
    );
  }

  deleteWorkflow(workflow: workflow_marketplace_item) {
    if (confirm(`¿Estás seguro de eliminar el workflow "${workflow.name}"?`)) {
      workflow_storage.deleteById(workflow.id);
      this.refreshData(); // Refrescar después de eliminar
      MessageService.toast(
        "Workflow eliminado correctamente",
        MessageService.TypeInfo
      );
    }
  }

  // === Método para refrescar datos ===
  async refreshData() {
    this.isRefreshing = true;
    
    try {
      // Simular un pequeño delay para mostrar el loading
      await new Promise(resolve => setTimeout(resolve, 300));
      
      this.refreshKey++;
      
      MessageService.toast(
        "Datos actualizados correctamente",
        MessageService.TypeInfo
      );
    } catch (error) {
      MessageService.toast(
        "Error al actualizar los datos",
        MessageService.TypeError
      );
    } finally {
      this.isRefreshing = false;
    }
  }

  // === Utilidades ===
  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString("es-ES", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }

  getStatusColor(workflow: workflow_marketplace_item): string {
    const daysSinceUpdate = Math.floor(
      (Date.now() - new Date(workflow.updatedAt).getTime()) /
        (1000 * 60 * 60 * 24)
    );

    if (daysSinceUpdate < 1) return "success";
    if (daysSinceUpdate < 7) return "warning";
    return "grey";
  }

  getStatusText(workflow: workflow_marketplace_item): string {
    const daysSinceUpdate = Math.floor(
      (Date.now() - new Date(workflow.updatedAt).getTime()) /
        (1000 * 60 * 60 * 24)
    );

    if (daysSinceUpdate < 1) return "Reciente";
    if (daysSinceUpdate < 7) return "Esta semana";
    return "Antiguo";
  }
}
